export default __webpack_public_path__ + "static/mobilehero-74ed8b20907b204d32d9f9f39e068727.jpg";